import React, { FC } from "react";
import styles from "./TableWrapper.module.scss";

const TableWrapper: FC = ({ children }) => {
  return (
    <div className={styles.TableWrapper} data-testid="TableWrapper">
      {children}
    </div>
  );
};

export default TableWrapper;
